import {filter, transform} from "lodash";

export const getInitSetting = (data, values) => {
    return transform(
        data,
        function (result, value, key) {
            const params = values?.length ? filter(values, { name: value.name }) : null

            return (result[value.name] = params && params[0] ? params[0].value : value?.default)
        },
        {},
    )
}